module.exports = __webpack_public_path__ + "media/images/emblems/Orny-coat_of_arms-f260eb07737d6f914bad37bf8648bbf9.svg";